import React, { useState } from "react";
import Modal from "../../components/Modal.js";
import imagen1 from "./assets/Med_No-01.jpg";
import Alcohol from "./assets/images/Alcohol.jpg";
import Tabaquismo from "./assets/images/Tabaco.jpg";
import Hidratacion from "./assets/images/Hidratacion.jpg";
import Medicamentos from "./assets/images/Medicamentos.jpg";
import Ejercicio from "./assets/images/Ejercicio.jpg";
import Consulta from "./assets/images/Consulta.jpg";
import { useNavigate } from "react-router-dom";
import "./Previas.css";
import "@fontsource/fira-sans";
import "@fontsource/fira-sans/700.css";
import "@fontsource/fira-sans/500.css";
import "@fontsource/fira-sans/400-italic.css";
import "@fontsource/fira-sans/200.css";

function Previas() {
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const handleAnterior = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };

  const handleSiguiente = () => {
    navigate("/indicaciones/dia-cirugia");
    window.scrollTo(0, 0);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 className="titlePreguntas_previas">Previo a tu cirugía</h1>
      <br></br>
      <div className="container_previas">
        <div id="card_1_previas">
          <h1>
            {" "}
            EVALUACIÓN POR MEDICINA <br></br>
            INTERNA Y/O CARDIOLOGÍA
          </h1>

          <p>
            Es aconsejable en caso de ser mayor a 50 años incluso si eres sano o
            antes si padeces alguna enfermedad crónica.
          </p>
        </div>
        <img
          src={Consulta}
          className="img-previas"
          id="image_1"
          alt="Imagen evaluación1"
        />
        <hr className="separador_previas"></hr>

        <img
          src={Tabaquismo}
          className="img-previas"
          id="image_2"
          alt="Tabaquismo"
        ></img>
        <div id="card_2_previas">
          <h1> TABAQUISMO</h1>
          <p>
            Suspender 4 a 6 semanas antes de tu cirugía ya que el tabaco reduce
            el nivel de oxigenación pulmonar, aumenta los problemas
            respiratorios transanestésicos y eleva los problemas de
            cicatrización hasta en un 50%.
          </p>
        </div>
        <hr className="separador_previas"></hr>

        <div id="card_1_previas">
          <h1>ALCOHOL</h1>
          <p>
            El consumo de alcohol es un predictor independiente de neumonía,
            sepsis, choque séptico e infección de la herida.
          </p>
        </div>
        <img
          src={Alcohol}
          className="img-previas"
          id="image_3"
          alt="Alcohol"
        ></img>

        <hr className="separador_previas"></hr>
        <img
          src={Hidratacion}
          className="img-previas"
          id="image_4"
          alt="Hidratacion"
        ></img>
        <div id="card_2_previas">
          <h1>HIDRATACIÓN</h1>
          <p>
            Mantente hidratado y disminuye la cantidad de cafeína y alcohol.
          </p>
        </div>

        <hr className="separador_previas"></hr>

        <div id="card_1_previas">
          <h1> EJERCICIO</h1>
          <p>
            Si tu padecimiento lo permite, trata de caminar al menos 20 a 30
            minutos al día, esto mejorará la fuerza muscular, así como la
            función cardiaca y pulmonar.
          </p>
        </div>
        <img
          src={Ejercicio}
          className="img-previas"
          id="image_5"
          alt="Ejercicio"
        ></img>

        <hr className="separador_previas"></hr>
        <img
          src={Medicamentos}
          className="img-previas"
          id="image_4"
          alt="Medicamentos"
        ></img>
        <div id="card_2_previas">
          <h1>MEDICACIONES A SUSPENDER</h1>
          <p>
            Es importante notificar si estás tomando análogos GLP-1 (para
            diabetes/bajar de peso), IECAS y ARAS (antihipertensivos) o
            anticoagulantes para discutir con tu médico si es factible suspender
            alguno de estos.
          </p>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <button
                onClick={() => setShowModal(true)}
                style={{
                  backgroundColor: "#134074",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  width: "fit-content",
                }}
              >
                Ver lista de medicamentos
              </button>
            </div>

            {showModal && (
              <Modal onClose={() => setShowModal(false)}>
                <h2 style={{ color: "#134074" }}>
                  Lista de medicamentos importantes
                </h2>
                <ul
                  style={{
                    textAlign: "left",
                    fontSize: "14px",
                    marginTop: "15px",
                  }}
                >
                  <li>
                    <strong>
                      <u>Inhibidores GLP-1</u>
                    </strong>
                    : Ozempic®, Wegovy®, Trulicity®, Victoza®, Saxenda®,
                    Byetta®, Bydureon®, Mounjaro®
                  </li>
                  <li>
                    <strong>
                      <u>Antihipertensivos</u>
                    </strong>
                    :
                    <ul>
                      <li>
                        <strong>Captopril</strong>: Capoten®, Acetensa®,
                        Capotenil®
                      </li>
                      <li>
                        <strong>Enalapril</strong>: Renitec®, Enalap®, Novatec®
                      </li>
                      <li>
                        <strong>Lisinopril</strong>: Prinivil®, Zestril®,
                        Lisinol®
                      </li>
                      <li>
                        <strong>Ramipril</strong>: Tritace®, Altace®
                      </li>
                      <li>
                        <strong>Perindopril</strong>: Coversyl®, Perindox®
                      </li>
                      <li>
                        <strong>Quinapril</strong>: Accupril®
                      </li>
                      <li>
                        <strong>Losartán</strong>: Cozaar®, Loten®, Aradois®
                      </li>
                      <li>
                        <strong>Valsartán</strong>: Diovan®, Vals®, Vartan®
                      </li>
                      <li>
                        <strong>Irbesartán</strong>: Aprovel®, Irtan®, Irbez®
                      </li>
                      <li>
                        <strong>Candesartán</strong>: Atacand®, Candez®
                      </li>
                      <li>
                        <strong>Olmesartán</strong>: Benicar®, Olmetec®
                      </li>
                      <li>
                        <strong>Telmisartán</strong>: Micardis®, Temisán®
                      </li>
                      <li>
                        <strong>Eprosartán</strong>: Teveten®
                      </li>
                      <li>
                        <strong>Combinaciones</strong>:
                        <ul>
                          <li>
                            <strong>Losartán + Hidroclorotiazida</strong>:
                            Cozaar Plus®, Lopresor H®
                          </li>
                          <li>
                            <strong>Valsartán + Hidroclorotiazida</strong>:
                            Diovan HCT®
                          </li>
                          <li>
                            <strong>Enalapril + Hidroclorotiazida</strong>:
                            Renitec D®
                          </li>
                          <li>
                            <strong>Telmisartán + Hidroclorotiazida</strong>:
                            Micardis Plus®
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>
                      <u>Anticoagulantes</u>
                    </strong>
                    :
                    <ul>
                      <li>
                        <strong>Warfarina</strong>: Coumadin®, Aldocumar®
                      </li>
                      <li>
                        <strong>Enoxaparina</strong>: Clexane®, Lovenox®
                      </li>
                      <li>
                        <strong>Dalteparina</strong>: Fragmin®
                      </li>
                      <li>
                        <strong>Nadroparina</strong>: Fraxiparina®
                      </li>
                      <li>
                        <strong>Heparina sódica</strong>: Liquemine®
                      </li>
                      <li>
                        <strong>Fondaparinux</strong>: Arixtra®
                      </li>
                      <li>
                        <strong>Argatrobán</strong>: Argatroban®
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>
                      <u>Antiplaquetarios</u>
                    </strong>
                    :
                    <ul>
                      <li>
                        <strong>Ácido Acetilsalicílico (Aspirina)</strong>:
                        Aspirina®, Aspec®, Acel®, Cardioaspirina®, Bufferin®,
                        Aspro®
                      </li>
                      <li>
                        <strong>Clopidogrel</strong>: Plavix®, Clopidogrel®,
                        Iscover®
                      </li>
                    </ul>
                  </li>
                </ul>
              </Modal>
            )}
          </div>
        </div>
      </div>

      {/* BOTONES */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginTop: "30px",
          marginBottom: "30px",
        }}
      >
        <button className="nav-button" onClick={handleAnterior}>
          Anterior
        </button>
        <button className="nav-button" onClick={handleSiguiente}>
          Siguiente
        </button>
      </div>
    </div>
  );
}

export default Previas;
